import { render, staticRenderFns } from "./AmlBlackDetailView.vue?vue&type=template&id=c23e1688&%40lo=true&"
import script from "./AmlBlackDetailView.vue?vue&type=script&lang=js&"
export * from "./AmlBlackDetailView.vue?vue&type=script&lang=js&"
import style0 from "./AmlBlackDetailView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports